
<script>
export default {
    name: 'CodeForm',
    props: {
      user: {
		type: Object,
		// required: true,
	  },
	  sended: {
		type: Boolean,
		// default: true
		// required: true,
	  },
	  sending: {
		type: Boolean,
		// required: true,
	  },
	  sendOTP: {
		type: Function,
		// required: true,
	  },
	  code: {
		type: String,
		// required: true,
	  }
    },
    data(){
        return {
			codes: [],
			wait: false,
        }
    },

	beforeMount(){
		this.codes = this.code.split('').map(n => parseInt(n))
		this.toWait()

	},
	watch: {
		code: {
			deep: true,
			immediate: true,
			handler: function (val, oldVal) {
				if (val === "" && this.codes !== []){
					this.codes = []
				}
			}
		},
    },

	methods: {

		toWait(){
			this.wait =  true
			setTimeout( () => this.wait = false, 360000) 
		},


		handleKeyDown(event, index) {
			if (event.key !== "Tab" && 
				event.key !== "ArrowRight" &&
				event.key !== "ArrowLeft"
			) {
				event.preventDefault();
			}
			
			if (event.key === "Backspace") {
				this.codes[index] = null;
				this.$refs['digit-'+index][0].value = null;
				if (index !== 0) {
					this.$refs['digit-'+(index-1)][0].focus();
				} 
				this.$emit('input', this.codes.join(''))
				return;
			}

			if ((new RegExp('^([0-9])$')).test(event.key)) {
				this.codes[index] = event.key;
				this.$refs['digit-'+index][0].value = event.key;
				if (index !== 5) {
					this.$refs['digit-'+(index+1)][0].focus();
				} else {
					if (this.codes.filter((x) => (Boolean(x))).length === 6){
						this.$emit('input', this.codes.join(''))
					} 
				}
			}
		}
	},

}
</script>


<template>
	<div id="wrapper" ref="wrapper">
		<div id="dialog" ref="dialog">

			<div v-if="true" id="form" >
				<p><b> Por favor ingresa en los próximos  5 minutos el código de verificación enviado a su correo electrónico.</b></p>
				
				<div>
					<input
					type="number"
					min="0"
					max="9"
					class="digit-box"
					v-for="(el, ind) in 6"
					:ref="'digit-'+ind"
					:key="el+ind"
					v-model="codes[ind]"
					value=""
					:autofocus="ind === 0 || codes.length === 0"
					:placeholder="ind+1"
					maxlength="1"
					@keydown="handleKeyDown($event, ind)"
					>
				</div>
				<span class="text-muted">Queremos asegurarnos que eres tu antes de restablecer la contraseña 😅</span>
				<div>
					¿No recibiste el código?<br />
					<span v-if="sending" class="text-primary">
						<b-spinner
						small
						label="Spinning"
						variant="primary"
						>
					</b-spinner>
					Sending...
					</span>
					<span v-if="wait && !sending"> <b-spinner small type="grow"></b-spinner> Intenta enviar enviar de nuevo el código en los siguientes 5 minutos, por favor espera.</span>

					<a  v-if="!sending && !wait" href="#" 
						@click="() => {
							$router.push({ name: 'forget-password'})
						}">Enviar código de nuevo.</a><br />
				</div>
			</div>


			

		</div>
	</div>
</template>


<style>
#wrapper {
	/* font-family: Lato; */
	/* font-size: 1.5rem; */
	text-align: center;
	box-sizing: border-box;
	color: #333;
}
#wrapper #dialog {
	/* border: solid 1px #ccc; */
	/* margin: 10px auto; */
	/* padding: 20px 30px; */
	display: inline-block;
	/* box-shadow: 0 0 4px #ccc; */
	/* background-color: #faf8f8; */
	overflow: hidden;
	position: relative;
	max-width: 650px;
}
#wrapper #dialog h3 {
	margin: 0 0 10px;
	padding: 0;
	line-height: 1.25;
}
#wrapper #dialog span {
	font-size: 90%;
}
#wrapper #dialog #form {
	max-width: 550px;
	margin: 25px auto 0;
}
#wrapper #dialog #form input {
	margin: 0 5px;
	text-align: center;
	line-height: 60px;
	font-size: 40px !important;
	border: solid 1px #ccc;
	box-shadow: 0 0 5px #ccc inset;
	padding-left: 0px !important;
	padding-right: 0px !important;
	outline: none;
	width: 13%;
	transition: all 0.2s ease-in-out;
	border-radius: 3px;
}

#wrapper #dialog #form input::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #f1f1f1;
  opacity: 1; /* Firefox */
}

#wrapper #dialog #form input:-ms-input-placeholder { /* Internet Explorer 10-11 */
  color: #f1f1f1;
}

#wrapper #dialog #form input::-ms-input-placeholder { /* Microsoft Edge */
  color: #f1f1f1;
}

#wrapper #dialog #form input:focus {
	border-color: rgb(4, 21, 170);
	box-shadow: 0 0 5px rgb(4, 21, 170) inset;
}
#wrapper #dialog #form input::selection {
	background: transparent;
}
#wrapper #dialog #form input[type=number] {
  -moz-appearance: textfield;
}
#wrapper #dialog #form input:-webkit-autofill{
  -webkit-text-fill-color: white !important;
}
#wrapper #dialog #form input::-webkit-outer-spin-button,
#wrapper #dialog #form input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
#wrapper #dialog #form button {
	margin: 30px 0 50px;
	width: 80%;
	padding: 6px;
	background-color: #b85fc6;
	border: none;
	text-transform: uppercase;
}
#wrapper #dialog button.close {
	border: solid 2px;
	border-radius: 30px;
	line-height: 19px;
	font-size: 120%;
	width: 22px;
	position: absolute;
	right: 5px;
	top: 5px;
}
#wrapper #dialog div {
	position: relative;
	z-index: 1;
}
#wrapper #dialog img {
	position: absolute;
	bottom: -70px;
	right: -63px;
}

.digit-box:focus {
  outline: 3px solid black;
}
</style>

